import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const intuit = defineConnector({
  identifier: "intuit",
  name: "Intuit",
  tagLine: "Accounting and financial platform",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: () => "https://quickbooks\\.api\\.intuit\\.com/.*",
  auth: oauthAuth,
  steps: [
    {
      title: "Create an Intuit app",
      items: [
        {
          kind: "markdown",
          content:
            "Open the [Intuit OAuth 2.0 app docs](https://developer.intuit.com/app/developer/qbo/docs/develop/authentication-and-authorization/oauth-2.0#create-an-app) and create an app in the Intuit developer portal. Copy the client ID and client secret from the app keys page.",
        },
      ],
    },
    {
      title: "Configure the redirect URI",
      items: [
        {
          kind: "markdown",
          content: "In your app’s settings, add the following redirect URI:",
        },
        {
          kind: "copyable",
          label: "Redirect URI",
          value: "{API_URL}/connected-apps/oauth/intuit/callback",
        },
      ],
    },
    {
      title: "Enter your app credentials",
      items: [
        {
          kind: "input",
          label: "Client ID",
          placeholder: "Paste your Client ID",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          placeholder: "Paste your Client secret",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
      ],
    },
    {
      title: "Authorize your Intuit account",
      items: [
        {
          kind: "markdown",
          content: "Click below to authorize your Intuit account.",
        },
        {
          kind: "oauth",
          dependsOn: [
            { kind: "oauthConnection", field: "clientId" },
            { kind: "oauthConnection", field: "clientSecret" },
          ],
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "authorization_code",
    authorizationEndpoint: () => "https://appcenter.intuit.com/connect/oauth2",
    tokenEndpoint: () =>
      "https://oauth.platform.intuit.com/oauth2/v1/tokens/bearer",
    tokenEndpointAuthMethod: () => "client_secret_post",
    clientCredentialsFrom: "db",
    scopes: () => [],
  },
  connectionTest: {
    protocol: "http",
    request: () => "https://quickbooks.api.intuit.com/",
  },
});
